import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette, typography, breakpoints }) => ({
  banner: {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    width: '100%',
    backgroundColor: palette.primary.main,
    borderRadius: '2rem 2rem 0 0',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    color: palette.common.white,
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      background: 'url(https://nova-live.imgix.net//MTLogoBackgroundV2.svg) no-repeat',
      backgroundSize: 'contain 100%',
      backgroundPosition: 'center',
      backgroundColor: palette.primary.main,
      padding: spacing(3),
      flexDirection: 'column',
      justifyContent: 'center',
      '@media (orientation: landscape)': {
        padding: spacing(1),
        alignItems: 'start'
      }
    }
  },
  container: {
    maxWidth: '1440px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      flexDirection: 'column',
      justifyContent: 'start'
    }
  },
  desktopBackground: {
    background: 'url(https://nova-live.imgix.net//MTLogoBackgroundV2.svg) no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0% 30%',
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      background: 'none'
    }
  }
}))
